import decamelizeKeys from 'decamelize-keys-deep'
import camelcaseKeys from 'camelcase-keys-deep'

export const camelize = <T>(obj: T): T => camelcaseKeys(obj)

export const decamelize = <T>(obj: T): T => decamelizeKeys(obj)
